import React, { useState } from 'react'
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { fetchData } from '../utils/fetchData';
import HorizontalScrollBar from './HorizontalScrollBar';
import Exercises from './Exercises';

const SearchExercises = ({ bodyPart, setBodyPart }) => {

  const [search, setSearch] = useState(" ")
  const [data, setData] = useState([])
  const [item, setItem] = useState()
  // console.log(item);
  //   const dtas = fetchData.data

  // useEffect(() => {
  //   const dta=dtas.map((dta)=>(
  //     setAllDta(dta.bodyPart)
  //   ))
  //   console.log(Alldta);
  // }, [])
  function handleSearch() {
    const data = fetchData.data

    const filterData = data.filter((item) => (
      item.name.toLowerCase().includes(search)
      || item.target.toLowerCase().includes(search)
      || item.equipment.toLowerCase().includes(search)
      || item.bodyPart.toLowerCase().includes(search)
    ))
    setSearch(" ")
    setData(filterData);
  }
  return (
    <div>
      <Stack alignItems="center" mt="37px" justifyContent="center" p="20px">
        <Typography fontWeight={700} sx={{ fontSize: { lg: '44px', xs: '30px' } }} mb="49px" textAlign="center">
          Awesome Exercises You <br /> Should Know
        </Typography>
        <Box position="relative" mb="72px">
          <TextField
            height="76px"
            sx={{ input: { fontWeight: '700', border: 'none', borderRadius: '4px' }, width: { lg: '1170px', xs: '350px' }, backgroundColor: '#fff', borderRadius: '40px' }}
            value={search}
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            placeholder="Search Exercises"
            type="text"
          />
          <Button className="search-btn" sx={{ bgcolor: '#FF2625', color: '#fff', textTransform: 'none', width: { lg: '173px', xs: '80px' }, height: '56px', position: 'absolute', right: '0px', fontSize: { lg: '20px', xs: '14px' } }} onClick={handleSearch}>
            Search
          </Button>
        </Box>
        <Box sx={{ position: 'relative', width: '100%', p: '20px' }}>
        </Box>
        <Box sx={{ position: 'relative', width: '100%', p: "20px" }}>
          <HorizontalScrollBar item={item} setItem={setItem} />
        </Box>
      </Stack>

      <Exercises search={search} setSearch={setSearch} item={item} bodyPart={bodyPart} setBodyPart={setBodyPart} setItem={setItem} data={data} />
    </div>
  )
}

export default SearchExercises
